export class EnhancedQuestion {
    id: string;
    created: Date;
    title: string;
    answers: string[];
    truncatedTitle: string;
    truncatedAnswer: string;
    isExpanded: boolean;
    isEditMode: boolean;
    needTruncate: boolean;

    // TODO smooth expanding section of question-answer
    stateAnswer = 'collapsed';

    truncateQuestion() {
        const maxLength = 200;
        if (this.title.length > maxLength) {
            this.needTruncate = true;
            this.truncatedTitle = this.title.substr(0, maxLength - 3) + '...';
        } else {
            this.truncatedTitle = this.title;
        }
    }
    truncateAnswer() {
        const text = this.answers.join('\n');
        const maxLength = 200;
        if (text.length > maxLength) {
            this.needTruncate = true;
            this.truncatedAnswer = text.substr(0, maxLength - 3) + '...';
        } else {
            this.truncatedAnswer = text;
        }
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/question.ts